import React, { Component } from 'react';
import { FormGroup, Label, Col } from '@Comp';
import { inject, observer } from 'mobx-react';
import { IndustrySectors } from '../../../services/requests';

@inject('businessProfileStore', 'commonStore')
@observer
class IndustrySectorSelector extends Component {
    constructor(props) {
        super(props);
        this.state = {
            industrySectors: [],
            allSectors: [],
            selectedSector: null,
            loading: false,
            dataFetched: false
        };
    }

    componentDidMount() {
        if (!this.state.dataFetched && !this.state.loading) {
            this.fetchIndustrySectors();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        // Load existing sector after sectors are fetched
        if (!prevState.dataFetched && this.state.dataFetched && this.state.allSectors.length > 0) {
            this.loadExistingSector();
        }
    }

    fetchIndustrySectors = async () => {
        if (this.state.loading || this.state.dataFetched) {
            return;
        }

        this.setState({ loading: true });

        try {
            const response = await IndustrySectors.getAll();
            console.log('Industry Sectors API Response:', response);

            if (response && response.data) {
                const responseData = response.data.data || response.data;
                console.log('Industry Sectors Data:', responseData);

                if (Array.isArray(responseData) && responseData.length > 0) {
                    // Map the flat structure to dropdown format
                    const allSectors = responseData.map(sector => ({
                        id: sector.id || sector._id,
                        name: sector.name,
                        code: sector.code,
                        description: sector.description
                    }));

                    console.log('Mapped Industry Sectors:', allSectors);

                    this.setState({
                        industrySectors: responseData,
                        allSectors: allSectors,
                        loading: false,
                        dataFetched: true
                    });
                } else {
                    console.warn('Industry sectors response is empty or invalid');
                    this.setState({ loading: false, dataFetched: true });
                }
            }
        } catch (error) {
            console.error('Error fetching industry sectors:', error);
            console.error('Error details:', error.response || error.message);
            this.setState({ loading: false, dataFetched: true });
        }
    };

    loadExistingSector = () => {
        const { companyDetails } = this.props.businessProfileStore.businessProfile;
        if (companyDetails && companyDetails.industrySector) {
            const sectorId = typeof companyDetails.industrySector === 'string'
                ? companyDetails.industrySector
                : companyDetails.industrySector.id || companyDetails.industrySector._id;

            const sector = this.state.allSectors.find(s => s.id === sectorId);
            if (sector) {
                this.setState({ selectedSector: sector });
            }
        }
    };

    handleSectorChange = (e) => {
        const sectorId = e.target.value;

        if (!sectorId) {
            this.setState({ selectedSector: null });
            if (this.props.businessProfileStore.businessProfile.companyDetails) {
                this.props.businessProfileStore.businessProfile.companyDetails.industrySector = null;
                this.props.businessProfileStore.fieldsToUpdate.companyDetailsDirty = true;
            }
            // Notify parent to enable save button
            if (this.props.formDataChange) {
                this.props.formDataChange({}, 'industrySector');
            }
            return;
        }

        const sector = this.state.allSectors.find(s => s.id === sectorId);
        this.setState({ selectedSector: sector }, () => {
            // Update the store without making an API call
            if (this.props.businessProfileStore.businessProfile.companyDetails) {
                this.props.businessProfileStore.businessProfile.companyDetails.industrySector = sectorId;
                this.props.businessProfileStore.fieldsToUpdate.companyDetailsDirty = true;
            }
            // Notify parent to enable save button
            if (this.props.formDataChange) {
                this.props.formDataChange({}, 'industrySector');
            }
        });
    };

    render() {
        const { allSectors, selectedSector, loading, dataFetched } = this.state;
        const { businessProfile } = this.props.businessProfileStore;

        return (
            <FormGroup className="row">
                <Label
                    className="col-sm-2 col-form-label control-label text-sm-right"
                    htmlFor="industrySector"
                    style={{ paddingLeft: '0px' }}
                >
                    INDUSTRY SECTOR
                </Label>
                <Col sm={10}>
                    <select
                        id="industrySector"
                        name="industrySector"
                        className="form-control"
                        value={selectedSector ? selectedSector.id : ''}
                        onChange={this.handleSectorChange}
                        disabled={!businessProfile.isEditable || allSectors.length === 0 || loading}
                        style={{ height: '40px' }}
                    >
                        <option value="">
                            {loading ? 'Loading industry sectors...' : allSectors.length === 0 ? 'No industries available' : 'Select Industry'}
                        </option>
                        {allSectors.map(sector => (
                            <option key={sector.id} value={sector.id}>
                                {sector.name}
                            </option>
                        ))}
                    </select>
                </Col>
            </FormGroup>
        );
    }
}

export default IndustrySectorSelector;
